import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../api/client";
import type { components } from "../api/types";

export type User = components["schemas"]["User"];

// useUser fetches GET /api/v1/me and treats 401 as "not logged in" (returns
// null), distinct from a real network/server error which throws.
//
// Cache lifetime is intentionally short for the auth boundary: the cookie
// can expire (sliding TTL on the orchestrator) at any time, so refetching
// on focus / mount keeps the UI honest. Slice 2's run-progress streaming
// shouldn't have to fight stale auth state.
export function useUser() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async (): Promise<User | null> => {
      const { data, error, response } = await apiClient.GET("/api/v1/me");
      if (error) {
        if (response.status === 401) return null;
        throw error;
      }
      return data ?? null;
    },
    retry: false,
    staleTime: 30_000,
  });
}
